/* ============================================================================
   WISHLIST -- vendor script, patched for Steam LB.

   Stored in a cookie called `wishlist`: product handles joined with "__".
   The page at /pages/wishlist fetches each product with ?view=for_wishlist
   (templates/product.for_wishlist.liquid) and stacks the rows.

   CHANGES FROM THE VENDOR VERSION:
   - The cookie lived for ONE day (setCookie(..., 1)), so a customer's saved list
     vanished overnight. Now WISHLIST_COOKIE_DAYS, a year.
   - The product-page branch looked for `.qnty-btn-wrp`, a wrapper that does not
     exist in this theme's main-product.liquid (it is `.pdp-btn-wrapper`), so the
     heart on a product page never showed as already-saved. Pointed at the real one.
   - Emptying the list left the cookie as "", which split into [""] and counted
     as one item. Handles now go through wishlistHandles(), which drops blanks.
   - The page was detected with an exact href match, so any ?query or trailing
     slash stopped the list from loading. Now matched on the path.
   - An empty wishlist showed a bare table header. It now says it is empty.
   ============================================================================ */

var WISHLIST_COOKIE_DAYS = 365;
var WISHLIST_EMPTY_HTML = '<p class="wishlist-empty" style="text-align:center;padding:40px 16px;color:#8d8d8d;font-size:15px;">Your wishlist is empty. Tap the heart on any product to save it here.</p>';

function wishlistHandles(raw) {
  return raw ? raw.split('__').filter(function (h) { return h; }) : [];
}

var getcookie = getCookie('wishlist');
if(getcookie){
    var splitcookie = wishlistHandles(getcookie);
    var active_wishlist = splitcookie.length;
    $('.pro-wishlist-sec .wishlist-head h3').find('span').text(active_wishlist);
      $('.wishlist-header a').find('span').text(active_wishlist);

  //first-code-card
    var handleFound = false;
      $( 'div.pro-btn-wrapper' ).each(function( index ) {
          var pro_handle = $(this).find(".pro-wishlist input").attr("pro-handle");
          var this_data = $(this);
          $.each(splitcookie, function( index, handle ) {
            if(pro_handle == handle){
              var handleFound = true;
              this_data.find(".pro-wishlist input").addClass("wishlist_active");
              this_data.find(".pro-wishlist").addClass("active");
              $(".pro-btn-wrapper .pro-wishlist.active").find("label .wishlist-label").html('<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path><use xlink:href="#icon-close"></use></svg>');
            }
          });
        });

  //product page
    if (!handleFound) {
        var pro_handle = $('.pdp-btn-wrapper').find(".pro-wishlist input").attr("pro-handle");
        var this_data = $('.pdp-btn-wrapper');
        if ($.inArray(pro_handle, splitcookie) !== -1) {
            this_data.find(".pro-wishlist input").addClass("wishlist_active");
            this_data.find(".pro-wishlist").addClass("active");
            $(".pdp-btn-wrapper .pro-wishlist.active").find("label .wishlist-label").html('<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="20" height="20" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path><use xlink:href="#icon-close"></use></svg>');
        }
    }
  }



$(document).on("change",'.pro-wishlist input',function(){
    var getoldcookie = getCookie('wishlist');

    if(getoldcookie){
      var splitoldcookie = wishlistHandles(getoldcookie);
      var oldcookieLength = splitoldcookie.length;
    }else{
      var oldcookieLength = 0;
    }

      $(this).addClass("wishlist_active");
      $(this).parents(".pro-wishlist").addClass("active");
      $(".pro-btn-wrapper .pro-wishlist.active").find("label .wishlist-label").html('<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path><use xlink:href="#icon-close"></use></svg>');
      $(".pdp-btn-wrapper .pro-wishlist.active").find("label .wishlist-label").html('<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="20" height="20" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path><use xlink:href="#icon-close"></use></svg>');
      var DataVal = $(this).attr("pro-handle");
      var getcookie = getCookie('wishlist');

      if(getcookie){
        var splitcookie = wishlistHandles(getcookie);
        var inarray = jQuery.inArray( DataVal, splitcookie );
        if(inarray < 0){
          splitcookie.push(DataVal);
        }else{
          splitcookie = $.grep(splitcookie, function(value) {
            return value != DataVal;
          });
        }
        var setcookie = splitcookie.join('__');
        setCookie('wishlist',setcookie,WISHLIST_COOKIE_DAYS);
      }else{
        setCookie('wishlist',DataVal,WISHLIST_COOKIE_DAYS);
      }

   // Count cookie items and update display
    var getcookie = getCookie('wishlist');
    var splitcookie = wishlistHandles(getcookie);
    var active_wishlist = splitcookie.length;
    $('.wishlist-header a').find('span').text(active_wishlist);


  //second-code-card
  var getcookie = getCookie('wishlist');
  $('div.wish-lbl-wrp').each(function (index) {
      if (getcookie) {
          var splitcookie = wishlistHandles(getcookie);
          var pro_handle = $(this).find(".pro-wishlist input").attr("pro-handle");
          var this_data = $(this);

          $.each(splitcookie, function (index, handle) {
              if (pro_handle == handle) {
                  this_data.find(".pro-wishlist input").addClass("wishlist_active");
                  this_data.find(".pro-wishlist").addClass("active");
                  $(".wish-lbl-wrp .pro-wishlist.active").find("label .wishlist-label").html('<svg xmlns="http://www.w3.org/2000/svg" id="Filled" viewBox="0 0 24 24" width="16" height="16" fill="#ff0000"><path d="M17.5,1.917a6.4,6.4,0,0,0-5.5,3.3,6.4,6.4,0,0,0-5.5-3.3A6.8,6.8,0,0,0,0,8.967c0,4.547,4.786,9.513,8.8,12.88a4.974,4.974,0,0,0,6.4,0C19.214,18.48,24,13.514,24,8.967A6.8,6.8,0,0,0,17.5,1.917Z"></path><use xlink:href="#icon-close"></use></svg>');
              }
          });
      }
  });

});
//page redirect -- a heart that is ALREADY saved acts as a link to the wishlist page
$(document).on("change",'.pro-wishlist input.wishlist_active',function(){
        var DataVal = $(this).attr("pro-handle");
        var getcookie = getCookie('wishlist');

      if(getcookie){
        var splitcookie = wishlistHandles(getcookie);

        var inarray = jQuery.inArray( DataVal, splitcookie );
        if(inarray < 0){
          splitcookie.push(DataVal);
        }else{
          splitcookie = $.grep(splitcookie, function(value) {
            return value != DataVal;
          });
        }
        var setcookie = splitcookie.join('__');
        setCookie('wishlist',setcookie,WISHLIST_COOKIE_DAYS);
      }else{
        setCookie('wishlist',DataVal,WISHLIST_COOKIE_DAYS);
      }

    if (window.location.pathname.includes('/ar')) {
      window.location.href = window.location.origin + "/ar/pages/wishlist";

    }else if(window.location.pathname.includes('/es')){
      window.location.href = window.location.origin + "/es/pages/wishlist";

    }else if(window.location.pathname.includes('/de')){
      window.location.href = window.location.origin + "/de/pages/wishlist";

    }else if(window.location.pathname.includes('/fr')){
      window.location.href = window.location.origin + "/fr/pages/wishlist";
    }else{
      window.location.href = window.location.origin + "/pages/wishlist";
    }
});

// for sigle product remove start
$(document).on('click','.wishlist-prod-remove', function(){
    var removeItem = $(this).parents(".wishlist-wrap").attr('data-handle');
    $(this).closest(".wishlist-wrap").remove();
    var splitcookie = wishlistHandles(getCookie('wishlist'));
    splitcookie = $.grep(splitcookie, function(value) {
      return value != removeItem;
    });
    var active_wishlist = splitcookie.length;
     $('.pro-wishlist-sec .wishlist-head h3').find('span').text(active_wishlist);
     $('.wishlist-header a').find('span').text(active_wishlist);
    var setcookie = splitcookie.join('__');
    setCookie('wishlist',setcookie,WISHLIST_COOKIE_DAYS);
    if (!active_wishlist) {
      $('.pro-wishlist-sec .pro-wishlist-wrap .pro-wishlist-scroll').html(WISHLIST_EMPTY_HTML);
    }
  });
// for sigle product remove end

// for all product clear start
$(document).on("click",".pro-wishlist-sec .clear-all-wishlist",function(event){
    event.preventDefault();
    setCookie('wishlist','',WISHLIST_COOKIE_DAYS);
    $('.pro-wishlist-sec .pro-wishlist-wrap .pro-wishlist-scroll').html(WISHLIST_EMPTY_HTML);
    $('.pro-wishlist-sec .wishlist-head h3').find('span').text('0');
    $('.wishlist-header a').find('span').text('0');

  });
// for all product clear end


//data get -- matched on the path, so ?utm= tags or a trailing slash still load the list
if (window.location.pathname.indexOf('/pages/wishlist') !== -1) {
  var wishlistPageHandles = wishlistHandles(getCookie('wishlist'));
  if (wishlistPageHandles.length) {
    wishlist(wishlistPageHandles);
  } else {
    $('.pro-wishlist-sec .pro-wishlist-wrap .pro-wishlist-scroll').html(WISHLIST_EMPTY_HTML);
  }
}

function wishlist(handle) {
  var wishlisthtml = '';
  count = 0;
  $.each(handle, function(index,value){

    if (window.location.pathname.includes('/ar')) {
      var href = "/ar/products/"+handle[index]+"?view=for_wishlist";

    }else if (window.location.pathname.includes('/es')){
      var href = "/es/products/"+handle[index]+"?view=for_wishlist";

    }else if(window.location.pathname.includes('/de')){
      var href = "/de/products/"+handle[index]+"?view=for_wishlist";

    }else if(window.location.pathname.includes('/fr')){
      var href = "/fr/products/"+handle[index]+"?view=for_wishlist";

    }else{
      var href = "/products/"+handle[index]+"?view=for_wishlist";
    }


    $.ajax({
      url:href,
      type:'GET',
      success: function(data1){
        wishlisthtml += data1;
      },
      complete: function(){
        $('.pro-wishlist-sec .pro-wishlist-wrap .pro-wishlist-scroll').html(wishlisthtml);
        count++;
        $('.wishlist-header a').find('span').text(count);
      }
    });
  });

}

function setCookie(name,value,days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days*24*60*60*1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
    var c = ca[i];
    while (c.charAt(0)==' ') c = c.substring(1,c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}
